// export const BASKET_ITEMS = 'BASKET_ITEMS'
// export type BASKET_ITEMS = typeof BASKET_ITEMS

const AUTH_CONFIG = {
    domain: 'accounts.florensis.com',
    clientId: 'MjOP2V26C28Frlci9lf8la2RCOt2TaAa',
    clientSecret: 'iGce4l0PSxss6JlAG4S6W-FQ1lNqHCm51RuybbnILysxelmWWjznajDF-jctuoxv',
    callbackUrl: location.origin + '/callback'
}

const API = {
    host: window.location.hostname === 'localhost' || 
          window.location.hostname.includes('test')
        ? 'https://florensis.test.florensis.com/api/v1/' 
        : 'https://www.florensis.com/api/v1/',
    currentHost: window.location.hostname === 'localhost' 
        ? 'https://surplus-florensis.test.florensis.com/api/' 
        : '/api/',
    endpoints: {
        account: 'account',
        clients: 'clients',
        login: 'account/login',
        surplus: 'surplus/app',
        order: 'orders/createsurplusorder'
    },
    status: {
        UNAUTHORIZED: 401,
        NOTFOUND: 404,
        SERVER_ERROR: 500
    }
}

const STORAGE_KEYS = {
    ACCESS_TOKEN: 'access_token',
    ID_TOKEN: 'id_token',
    EXPIRES: 'expires_at',
    BASKET_ITEMS: 'basket_items',
    ACCOUNT: 'account',
    CLIENT: 'client',
    SEARCH: 'search'
}

const PAGE_TYPES = {
   HOME: 'home',
   SEARCH: 'search',
   CONSTACT: 'contact',
   PRODUCTS: 'product overview',
   CART: 'cart',
   CHECKOUT: 'checkout',
   PURCHASE: 'purchase',
   LOGIN: 'login',
   LOGOUT: 'logout'
}
// export type AUTH_CONFIG = typeof AUTH_CONFIG

export {
    AUTH_CONFIG,
    API,
    STORAGE_KEYS,
    PAGE_TYPES
}



// WEBPACK FOOTER //
// ./src/constants/index.ts